module.exports = __webpack_public_path__ + "images/pro/statistics-d86709acdd4efce3da28a72836ccbeb5.png";